import React from 'react';
import { Box, Link } from '@mui/material';
import { Checkbox, Typography } from '@sm-dashboard/ui-components';
import { SHALIACH_REGULATIONS_LINK } from '../../../../../constants/businessAds.constants';

interface RegulationsAndApprovalProps {
  agreed: boolean;
  setAgreed: (agreed: boolean) => void;
}

const RegulationsAndApproval: React.FC<RegulationsAndApprovalProps> = ({ agreed, setAgreed }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ mb: '0.35em' }}>
        <Typography variant="h6">תקנון ואישור</Typography>
      </Box>

      <Box
        sx={{
          my: 3,
          p: 3,
          border: '1px solid #ddd',
          borderRadius: 1,
          backgroundColor: '#f9f9f9',
          textAlign: 'center'
        }}
      >
        <Box sx={{ mb: '0.35em' }}>
          <Typography variant="body">על מנת להשלים את תהליך הפרסום, עליך לקרוא ולאשר את תקנון השימוש.</Typography>
        </Box>

        <Box sx={{ my: 3 }}>
          <Link
            href={SHALIACH_REGULATIONS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
            sx={{ fontSize: '1.1rem', fontWeight: 500 }}
          >
            תקנון לוח חב"ד - פרסום בבעלות שליח
          </Link>
        </Box>
        <Box sx={{ my: 3 }}>
          <Typography variant="body2" color="text.secondary">
            אני מודע כי השירות החינמי במסלול השלוחים ניתן לעסק בבעלות שליח בלבד אני מאשר כי הפרסום הוא של עסק בבעלותי
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          לחץ על הקישור לעיל כדי לקרוא את התקנון המלא
        </Typography>
      </Box>

      <Checkbox checked={agreed} onChange={e => setAgreed(e.target.checked)} label="קראתי את התקנון ואני מאשר/ת" />
    </Box>
  );
};

export default RegulationsAndApproval;
